<template>
  <div class="commandPage">
    <el-table
      stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
      row-key="id"
      :cell-style="colStyle"
    >
      <el-table-column
        type="index"
        :width="80"
        align="center"
        class-name="drag_move"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="命令名称"
        max-width="110px"
        align="left"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.title"
            class="allowSkip"
            @click="clickAllowSkip(scope.row)">{{ scope.row.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        min-width="130px"
        label="命令详情"
        align="left"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.name"
            >{{ scope.row.name }}</span
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="command"
        min-width="110px"
        label="命令字"
        align="left"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.command"
            placement="top"
            :open-delay="300"
          >
            <div class="textOverflow" v-if="scope.row.command">
              {{ scope.row.command }}
            </div>
          </el-tooltip>
          <span v-if="!scope.row.command">-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="factoryToolId=='1' || factoryToolId=='91139408890441728'" 
        prop="station"
        label="所在工序"
        max-width="110px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.station">{{ scope.row.station.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column v-if="factoryToolId!='1' && factoryToolId!='91139408890441728'" 
        prop="workStation"
        label="所属工序"
        max-width="110px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.workStation">{{ scope.row.workStation.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="type"
        label="执行方式"
        max-width="110px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.type">{{ scope.row.type.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="onlyTuya"
        label="产测协议"
        max-width="110px"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.onlyTuya">{{ scope.row.onlyTuya.title }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        class-name="operation"
        label="操作"
        align="center"
        width="95px"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="修改"
            placement="top"
            :open-delay="300"
          >
            <i @click="factoryCommandEdit(scope.row)" class="el-icon-edit"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="上移"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="moveUpCommand($event, scope.row)"
              class="el-icon-arrow-up"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="下移"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="moveDownCommand($event, scope.row)"
              class="el-icon-arrow-down"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="命令详情"
      :visible.sync="dialogVisible"
      width="800px"
      @close="dialogClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="50vh"
      class="myDialog detailDialog"
      v-dialogDrag
    >
      <ul class="ulBox clearFloat">
        <li>
          <div class="left">命令名称：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.title">{{
              factoryCommandDetailData.title
            }}</span>
            <span class="noValue" v-else>无</span>
          </div>
        </li>
        <li>
          <div class="left">命令详情：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.name">{{
              factoryCommandDetailData.name
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">所在工序：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.station">{{
              factoryCommandDetailData.station.title
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">执行方式：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.type">{{
              factoryCommandDetailData.type.title
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">命令字：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.command">{{
              factoryCommandDetailData.command
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">产测协议：</div>
          <div class="right">
            <span v-if="factoryCommandDetailData.onlyTuya">{{ factoryCommandDetailData.onlyTuya.title }}</span>
            <span v-else>-</span>
          </div>
        </li>
        <li class="blockLi">
          <div class="left">执行参数：</div>
          <div class="right">
            <el-input
              v-if="factoryCommandDetailData.data"
              class="detailTextArea"
              type="textarea"
              :readonly="true"
              :autosize="{ minRows: 1, maxRows: 8 }"
              resize="none"
              v-model="factoryCommandDetailData.data"
            ></el-input>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">Tips：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.tips">{{
              factoryCommandDetailData.tips
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="left">Tips按钮：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.showButton"
              >显示</span
            >
            <span class="noValue" v-else>隐藏</span>
          </div>
        </li>
        <li>
          <div class="left">超时(秒)：</div>
          <div class="right">
            <span class="value">{{ factoryCommandDetailData.timeout }}</span>
          </div>
        </li>
        <li>
          <div class="left">超时提示：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.timeoutTips">{{
              factoryCommandDetailData.timeoutTips
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
        <li>
          <div class="">初始化执行：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.execInit"
            >是</span
            >
            <span class="noValue" v-else>否</span>
          </div>
        </li>
        <li class="blockLi">
          <div class="left">功能说明：</div>
          <div class="right">
            <span class="value" v-if="factoryCommandDetailData.notes">{{
              factoryCommandDetailData.notes
            }}</span>
            <span class="noValue" v-else>-</span>
          </div>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button
          type="primary"
          size="small"
          @click="factoryCommandEdit(factoryCommandDetailData)"
        >修改</el-button> -->
        <el-button
          type="primary"
          size="small"
          @click="closeDetail"
          >关闭</el-button>
      </div>
    </el-dialog>
    <myDialog
      ref="commanAddAndEditDialog"
      :title="commanAddAndEditTitle"
      @submitData="commanAddAndEditSubmit"
      @dialogClose="commanAddAndEditClose"
      width="650px"
    >
      <template slot="content">
        <el-form
          ref="commanAddAndEditForm"
          :model="commanAddAndEditForm"
          :rules="commanAddAndEditRules"
          :label-width="labelWidth"
        >
          <el-form-item
            label="名称"
            size="small"
            prop="name"
            class="inlineItem"
          >
            <el-input
              v-model="commanAddAndEditForm.name"
              placeholder="命令内部名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="标题"
            size="small"
            prop="title"
            class="inlineItem"
          >
            <el-input
              v-model="commanAddAndEditForm.title"
              placeholder="显示在产测工具按钮上的名称"
              clearable
            ></el-input>
          </el-form-item> 
          <el-form-item v-if="factoryToolId=='1' || factoryToolId=='91139408890441728'"
            label="所在工序"
            size="small"
            prop="station"
            class="inlineItem"
          >
            <el-select
              v-model="commanAddAndEditForm.station"
              placeholder="选择所在工序"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in $parent.pullDownData.factoryStationList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="所属工序：" size="small" prop="workStationId"  class="inlineItem" v-if="factoryToolId!='1'&& factoryToolId!='91139408890441728'">
              <el-cascader
                :options="$parent.pullDownData.workStationList"
                :props="cascaderOption"
                :show-all-levels="false"
                v-model="commanAddAndEditForm.workStationId"
                ref="workStationCascader"
                @change="cascaderChange($event, 'workStationCascader')"
                placeholder="选择工序"
                popper-class="workStationCascader"
                clearable
              ></el-cascader>
          </el-form-item>

          <el-form-item
            label="执行方式"
            size="small"
            prop="type"
            class="inlineItem"
          >
            <el-select
              v-model="commanAddAndEditForm.type"
              placeholder="选择执行方式"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in $parent.pullDownData.commandTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="命令字"
            size="small"
            prop="command"
            class="inlineItem"
          >
            <el-input
              v-model="commanAddAndEditForm.command"
              placeholder="命令字"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="产测协议"
            size="small"
            prop="onlyTuya"
            class="inlineItem"
          >
            <el-select
              v-model="commanAddAndEditForm.onlyTuya"
              placeholder="选择产测协议"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in $parent.pullDownData.agreementList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行参数" size="small" prop="data">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 8 }"
              v-model="commanAddAndEditForm.data"
              placeholder="执行参数"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Tips"
            size="small"
            prop="tips"
            class="inlineItem"
          >
            <el-input
              v-model="commanAddAndEditForm.tips"
              placeholder="描述信息"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Tips按钮"
            size="small"
            prop="showButton"
            class="inlineItem"
          >
            <el-radio v-model="commanAddAndEditForm.showButton" :label="true"
              >显示</el-radio
            >
            <el-radio v-model="commanAddAndEditForm.showButton" :label="false"
              >隐藏</el-radio
            >
          </el-form-item>
          <el-form-item
            label="超时(秒)"
            size="small"
            prop="timeout"
            class="inlineItem"
          >
            <el-input
              v-model="commanAddAndEditForm.timeout"
              placeholder="超时时间"
              @input="timeoutInput($event, 'commanAddAndEditForm', 'timeout')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="超时提示"
            size="small"
            prop="timeoutTips"
            class="inlineItem"
          >
            <el-input
              v-model="commanAddAndEditForm.timeoutTips"
              placeholder="超时提示"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
              label="初始化执行"
              size="small"
              prop="execInit"
              class="inlineItem"
          >
            <el-radio v-model="commanAddAndEditForm.execInit" :label="true"
            >是</el-radio>
            <el-radio
                v-model="commanAddAndEditForm.execInit"
                :label="false"
            >否</el-radio>
          </el-form-item>
          <el-form-item label="功能说明" size="small" prop="notes">
            <!-- <el-input v-model="commanAddAndEditForm.notes" placeholder="说明" clearable></el-input> -->
            <el-input
              type="textarea"
              :rows="2"
              v-model="commanAddAndEditForm.notes"
              placeholder="功能说明"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import myDialog from "@/components/myDialog.vue";
import {
  apiFactoryCommandSearch,
  apiFactoryCommandDisable,
  apiFactoryCommandEnable,
  apiFactoryCommandMoveDown,
  apiFactoryCommandMoveUp,
  apiFactoryCommandDetail,
  apiFactoryCommandAdd,
  apiFactoryCommandUpdate, apiFactoryCommandDragSort,
} from "@/api/factoryTools.js";
export default {
  components: {
    myDialog,
  },
  props: {
    factoryToolId: { type: String },
    toolsLink: {
      type: String,
    },
    commandSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      // 联级配置
      cascaderOption: {
        checkStrictly: true,
        emitPath: false,
        label: "name",
        value: "id",
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      dialogVisible: false,
      factoryCommandDetailData: {},
      commanAddAndEditTitle: "",
      commanAddAndEditForm: {
        showButton: true,
        onlyTuya: "All",
        execInit: false,
      },
      commanAddAndEditRules: {
        name: [
          { required: true, message: "命令详情不能为空！", trigger: "blur" },
        ],
        title: [
          { required: true, message: "命令名称不能为空！", trigger: "blur" },
        ],
        station: [
          { required: true, message: "所在工序不能为空！", trigger: "change" },
        ],
        type: [
          { required: true, message: "执行方式不能为空！", trigger: "change" },
        ],
        workStationId: [
          { required: true, message: "所属工序不能为空！", trigger: "blur" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  mounted () {
    this.rowDrop();
  },
  methods: {
    closeDetail() {
        this.dialogVisible = false;
    },
    // 表格数据
    async getFactoryCommandSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiFactoryCommandSearch({
        factoryToolId: this.factoryToolId,
        ...this.commandSearchForm,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        if (callback) callback();
      }
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      if (val) {
        let workStationList = this.$parent.pullDownData.workStationList;
        this.$refs[ref].toggleDropDownVisible();
        workStationList.forEach((item) => {
          if (item.children) {
            item.children.forEach((child) => {
              // console.log(val == child.id)
              val == child.id;
            });
          }
        });
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getFactoryCommandSearch();
    },
    // 禁用
    disableCommand(e, row) {
      e.target.blur();
      this.$allOperation(row, "禁用", "命令").then(async () => {
        const res = await apiFactoryCommandDisable({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryCommandSearch("noRemove");
          this.$message({
            message: "禁用成功",
            type: "success",
          });
        }
      });
    },
    // 启用
    enableCommand(e, row) {
      e.target.blur();
      this.$allOperation(row, "启用", "命令").then(async () => {
        const res = await apiFactoryCommandEnable({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryCommandSearch("noRemove");
          this.$message({
            message: "启用成功",
            type: "success",
          });
        }
      });
    },
    // 上移
    moveUpCommand(e, row) {
      e.target.blur();
      this.$confirm(`是否上移【${row.name}】？`, "上移命令", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiFactoryCommandMoveUp({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryCommandSearch("noRemove");
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
      });
    },
    // 下移
    moveDownCommand(e, row) {
      e.target.blur();
      this.$confirm(`是否下移【${row.name}】？`, "下移命令", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiFactoryCommandMoveDown({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryCommandSearch("noRemove");
          this.$message({
            message: "下移成功",
            type: "success",
          });
        }
      });
    },
    // 表格列命令名称点击
    async clickAllowSkip(row) {
      const res = await apiFactoryCommandDetail({
        id: row.id,
      });
      // console.log(res);
      if (res.code == 0) {
        this.dialogVisible = true;
        this.factoryCommandDetailData = res.data;
      }
    },
    dialogClose() {
      document.querySelectorAll(".el-dialog").forEach((item) => {
        setTimeout(() => {
          item.style.left = "0";
          item.style.top = "0";
        }, 500);
      });
    },
    // 添加产测命令
    factoryCommandAdd() {
      this.commanAddAndEditTitle = "添加命令";
      this.$refs.commanAddAndEditDialog.dialogVisible = true;
    },
    // 修改产测命令
    factoryCommandEdit(data) {
      this.commanAddAndEditTitle = "修改命令";
      this.$refs.commanAddAndEditDialog.dialogVisible = true;
      let station = data.station !=undefined ? data.station.code : null;
      let workStationId=data.workStation !=undefined ? data.workStation.id : null;
      this.commanAddAndEditForm = {
        ...data,
        workStationId: workStationId,
        factoryToolId: this.factoryToolId,
        station: station,
        type: data.type.code,
        onlyTuya:data.onlyTuya.code,
      };
    },
    // 超时时间
    timeoutInput(value, formName, name) {
      let newValue = value.replace(/[^\d]/g, "");
      this.$set(this[formName], name, newValue);
    },
    // 添加和编辑命令提交
    async commanAddAndEditSubmit() {
      this.$refs.commanAddAndEditForm.validate(async (valid) => {
        if (valid) {
          if (this.commanAddAndEditTitle == "添加命令") {
            const res = await apiFactoryCommandAdd({
              factoryToolId: this.factoryToolId,
              ...this.commanAddAndEditForm,
            });
            // console.log(res);
            if (res.code == 0) {
              this.$refs.commanAddAndEditDialog.dialogVisible = false;
              this.getFactoryCommandSearch();
              this.$message({
                type: "success",
                message: "添加成功",
              });
            }
          } else if (this.commanAddAndEditTitle == "修改命令") {
            const res = await apiFactoryCommandUpdate({
              ...this.commanAddAndEditForm,
            });
            // console.log(res);
            if (res.code == 0) {
              this.$refs.commanAddAndEditDialog.dialogVisible = false;
              this.getFactoryCommandSearch("noRemove");
              this.$message({
                type: "success",
                message: "修改成功",
              });
              const resDetail = await apiFactoryCommandDetail({
                id: res.data.id,
              });
              // console.log(res);
              if (resDetail.code == 0) {
                this.factoryCommandDetailData = resDetail.data;
              }
            }
          }
        } else {
          return false;
        }
      });
    },
    // 添加和编辑命令关闭
    commanAddAndEditClose() {
      this.$refs.commanAddAndEditForm.resetFields();
      this.commanAddAndEditForm = {
        showButton: true,
        onlyTuya: "All",
        execInit: false,
      };
    },
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody');
      const _this = this;
      let tempName = '';
      let tempId = '';
      Sortable.create(tbody, {
        //  指定父元素下可被拖拽的子元素
        draggable: ".el-table__row",
        animation:500,
        handle: ".drag_move",
        onStart(evt) {
          const index=evt.oldIndex;
          const oldIndexRow  = _this.tableData.slice(index,index+1)[0];
          tempName = oldIndexRow.title;
          tempId = oldIndexRow.id;
        },
        onEnd ({ newIndex, oldIndex }) {
          if(newIndex == oldIndex){
            return;
          }
          let newIndexTemp = newIndex + 1;
          let oldIndexTemp = oldIndex + 1;
          // console.log(tempId);
          _this.$confirm('确定将【'+ tempName +'】从第【'+oldIndexTemp+'】行排序到第【'+newIndexTemp+'】行', "排序工具", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            const res = await apiFactoryCommandDragSort({
              id: tempId,
              sortNum: newIndex
            });
            console.log(res)
            if (res.code == 0) {
              _this.getFactoryCommandSearch("noRemove");
              _this.$message({
                message: "排序成功",
                type: "success",
              });
            }else {
              _this.getFactoryCommandSearch("noRemove");
            }
          }).catch(()=>{
            _this.getFactoryCommandSearch("noRemove");
          });
          const currRow = _this.tableData.splice(oldIndex, 1)[0];
          _this.tableData.splice(newIndex, 0, currRow);
          // _this.sortableResult = JSON.stringify(_this.tableData);
        }
      })
    },
    colStyle({columnIndex}) {
      if (columnIndex ==0) {
        return 'cursor: move;'
      }
    }
  },

};
</script>

<style lang="less" scoped>
.commandPage {
  height: 100%;
  display: flex;
  flex-direction: column;
  /deep/.detailTextArea textarea {
    border: 0;
    cursor: auto;
    padding: 3px 0;
  }
}
</style>
